import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// Redux
import { RootState } from '@redux/store';

// import module
import { ClickOutside } from '@lion-design/core';

// component
import Session from '@Common/session';
import TicketBlock from '../TicketBlock';

// source config

//styles
import './style.scss';

// common function
import { ClassData } from '@libs/globalVariables';

// plugin
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

export interface ISeatPickerProps { // PC&M 共用
    disabled: Boolean;
    disabledSessions: Array<string>;
    error: Boolean;
    whenSeatsChange: (data: any) => void;
    seatClassSelected: string;
}
export interface ISeatInfo { // PC&M 共用
    [key: string]: number;
}

const SeatPickerPC: React.FC<ISeatPickerProps> = (props) => {
    const { t } = useTranslation();

    const { Language } = useSelector((state: RootState) => state.Common);
    let lang: string;
    // 香港語系翻譯檔與台灣相同
    Language === 'zh-hk' ? lang = 'zh-tw' : lang = Language;
    const store_THSR = useSelector((state: RootState) => state.THSR);
    //目前所選的車廂類型index(trainItem.ClassTickets)
    const [classIndex, setClassIndex] = useState<number>(0);

    //F:成人票(全票) E:敬老票 W:愛心票 H:孩童票
    const defaultSeatInfo = store_THSR.THSRInitData.TrainTickets.reduce(
        (a, v) => ({ ...a, [v.TicketId]: v.LowQty }),
        {}
    );
    //{F:0,H:0,E:0,W:0}
    //F是成人票默認2人
    defaultSeatInfo.F = 2;
    const [seatInfo, setSeatInfo] = useState<ISeatInfo>(defaultSeatInfo);
    //要禁止點擊的艙等
    const disabledSessions = props.disabledSessions || [''];

    const renderSeatClass = () => {
        const sessionProps = {
            sessionPicked: ClassData[lang][classIndex].value,
            option: ClassData[lang],
            itemClick: (index) => {
                if (disabledSessions.includes(ClassData[lang][index].value)) {
                    return false;
                }
                //更換艙等
                setClassIndex(index);
            },
            isGDS: false,
            disabledSessions: disabledSessions,
        };

        return (
            <div className="sessionBlock">
                <Session {...sessionProps} />
            </div>
        );
    };
    const returnSeatNum = (obj) => {
        let num = 0;
        if (obj) {
            Object.keys(obj).forEach((child) => {
                num += obj[child];
            });
        }
        return num;
    };

    // 初始化座位
    useEffect(() => {
        props.whenSeatsChange &&
            props.whenSeatsChange({
                seatClass: ClassData[lang][classIndex].value,
                seatInfo: seatInfo,
            });
    }, []);

    useEffect(() => {
        props.whenSeatsChange &&
            props.whenSeatsChange({
                seatClass: ClassData[lang][classIndex].value,
                seatInfo: seatInfo,
            });
    }, [props, lang, classIndex, seatInfo]);

    useEffect(() => {
        if (props?.seatClassSelected === 'Y' && classIndex !== 0) {
            setClassIndex(0);
        }
        if (props?.seatClassSelected === 'J' && classIndex !== 1) {
            setClassIndex(1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.seatClassSelected]);

    return (
        <ClickOutside className="seatPickerPC">
            <ClickOutside.Trigger>
                <div
                    className={cx('ClickOutside-placeholder', {
                        error: props.error,
                        disabled: props.disabled,
                    })}
                >
                    <span className="label">{t('THSR.commonPanel.carriageAndHeadcount')}</span>
                    <br />
                    <span>
                        {ClassData[lang][classIndex].text}, {t('THSR.commonPanel.all')} {returnSeatNum(seatInfo)} {t('THSR.commonPanel.people')}
                    </span>
                </div>
            </ClickOutside.Trigger>
            {!props.disabled && (
                <ClickOutside.Window>
                    <div className="seatPickerWindow">
                        <TicketBlock
                            seatInfo={seatInfo}
                            whenChange={(v) => {
                                setSeatInfo({ ...seatInfo, ...v });
                            }}
                        />
                        {renderSeatClass()}
                    </div>
                </ClickOutside.Window>
            )}
        </ClickOutside>
    );
};

export default SeatPickerPC;